import { createApp, ref } from "vue";
import { createPinia } from "pinia";
import { createPersistedState } from "pinia-plugin-persistedstate";
import App from "./App.vue";
import router from "./router";
import { createI18n } from "vue-i18n";
import messages from "@/translations/index";
import "@vuepic/vue-datepicker/dist/main.css";
import clickOutside from "@/services/v-click-outside";
import { handleClick } from "@/services/customEvent";
import ToastPlugin from "vue-toast-notification";
// import "vue-toast-notification/dist/theme-bootstrap.css";
// import "vue-toast-notification/dist/theme-default.css";
import "vue-toast-notification/dist/theme-sugar.css"; // 보통 이거 씀

const i18n = createI18n({
    locale: "KO",
    messages: messages,
    legacy: false,
    globalInjection: true,
});

const pinia = createPinia();
pinia.use(
    createPersistedState({
        storage: localStorage,
        auto: true,
    }),
);

const app = createApp(App);
app.directive("click-outside", clickOutside);
app.provide("author", ref({ clfCd: 0 as any }));
app.use(pinia);
app.use(router);
app.use(i18n);
app.use(ToastPlugin, {
    position: "top-right",
    duration: 4000,
    dismissible: true,
});

(window as any).handleClick = handleClick;

app.mount("#app");
